module.exports = __webpack_public_path__ + "img/agua-sanitaria-mobile-1.e9ec9271.png";